var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('holidaysview'),_c('router-link',{staticClass:"flix-html-a",attrs:{"to":{name: 'dashboardHolidays'}}},[_c('b-flix-icon',{attrs:{"icon":"cogwheel"}}),_vm._v(" "+_vm._s(_vm.$tc('message.additionalSettings',)))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }